<template>
  <div>
    <b-tabs>
      <b-tab :active="totalIceContractApproval > 0"
             :title="$t('sandoz.contract_approvals') + ' (' + totalIceContractApproval + ')'"
             :title-item-class="totalIceContractApproval <= 0 ? 'd-none' : ''">
        <o-table ref="tableList" :custom-row-button="true" :enable-delete="false" :enable-edit="false"
                 :enable-new="false" :enable-view="false" :hide-if-empty="true" :title="''" class="sticky-last-row"
                 url="/api/sandoz/approvals?include=master_address_single,latest_pdf,latest_import_job,word_files,kukos"
                 @total="handleIceContractTotal">
          <template slot="filter">
            <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)">
              <o-filter-text :title="$t('sandoz.contract_no')" column="contract_no"></o-filter-text>
              <o-filter-text :title="$t('sandoz.customer_external_id')" column="customer_external_id"></o-filter-text>
              <o-filter-text :title="$t('sandoz.responsible_sales_person')"
                             column="responsible_sales_person"></o-filter-text>
              <o-filter-select :items="status" :title="$t('sandoz.status')" column="status"></o-filter-select>
              <o-filter-select :items="years" :title="$t('sandoz.contract_year')"
                               column="contract_year"></o-filter-select>
            </o-filter>
          </template>
          <template slot="head">
            <o-table-header column="contract_no">{{ $t('sandoz.contract_no') }}</o-table-header>
            <o-table-header column="responsible_sales_person">{{
                $t('sandoz.responsible_sales_person')
              }}
            </o-table-header>
            <o-table-header column="contract_start">{{ $t('sandoz.contract_start') }}</o-table-header>
            <o-table-header column="status">{{ $t('sandoz.status') }}</o-table-header>
            <o-table-header :sortable="false" :title="$t('sandoz.name')">{{ $t('sandoz.name') }}</o-table-header>
            <o-table-header :title="$t('sandoz.turnover')" column="contract_no">{{ $t('sandoz.turnover') }} /
              {{ $t('sandoz.turnover_expectation') }}
            </o-table-header>
            <o-table-header :title="$t('sandoz.invest_growth')" column="invest_growth">{{
                $t('sandoz.invest_growth')
              }}
            </o-table-header>
            <o-table-header :title="$t('sandoz.marketing_activities')" column="marketing_activities">
              {{ $t('sandoz.marketing_activities') }}
            </o-table-header>
            <o-table-header :sortable="false" :title="$t('sandoz.discount')" column="discount">{{
                $t('sandoz.discount')
              }}
            </o-table-header>
            <o-table-header :title="$t('sandoz.finished_approvals')" column="next_approver">
              {{ $t('sandoz.finished_approvals') }}
            </o-table-header>
            <th>&nbsp;</th>
          </template>
          <template slot="body" slot-scope="props">
            <td>{{ props.item.contract_no }}
              <router-link :to="{ name: contractRoute(props.item), params: { id: props.item.id }}">
                <fa icon="arrow-right"/>
              </router-link>
            </td>
            <td>{{ props.item.responsible_sales_person }}</td>
            <td>{{ props.item.contract_start | formatDate }}</td>
            <td>
              {{ $t('sandoz.' + props.item.status.toLowerCase()) }}
              <span v-if="props.item.reason_businesscase"
                    v-b-popover.hover="{ variant: 'info',  content: props.item.reason_businesscase }"
                    class="badge badge-warning">{{ $t('sandoz.business_case') }}</span>
              <span v-if="props.item.cap_exceeded"
                    class="badge badge-danger text-capitalize">{{ $t('sandoz.cap_exceeded') }}</span>
              <span v-if="props.item.deviation_outside_margin"
                    class="badge badge-orange">{{ $t('sandoz.deviation_outside_margin') }}</span>
              <span v-if="props.item.deviation_outside_margin === 0"
                    class="badge badge-success">{{ $t('sandoz.deviation_inside_margin') }}</span>
            </td>
            <td>
              <template v-if="props.item.master_address_single && props.item.master_address_single.data">
                <template
                  v-if="props.item.master_address_single.data.name || props.item.master_address_single.data.last_name">
                  {{
                    props.item.master_address_single.data.name + ' ' + props.item.master_address_single.data.last_name + (props.item.master_address_single.data.company_name ? ' (' + props.item.master_address_single.data.company_name + ')' : '')
                  }}
                </template>
                <template v-else>
                  {{ props.item.master_address_single.data.company_name }}
                </template>
              </template>
            </td>
            <td>
              {{ props.item.turnover | formatInteger }}<br>
              {{ props.item.turnover_expectation | formatInteger }}

              <a v-if="props.item.turnover_gx_expectation || props.item.turnover_otc_expectation"
                 href="javascript:void(0);"
                 @click="openTurnoverModal(props.item)">
                <fa icon="info-circle"></fa>
              </a>

            </td>
            <td>{{ props.item.invest_growth | formatPercentage }}%</td>
            <td>
              <template
                v-if="props.item.marketing_activities_maximum !== null && props.item.marketing_activities_maximum !== '0.00'">
                {{ props.item.marketing_activities_maximum | formatInteger }}<br>
                {{ props.item.marketing_activities_percentage | formatPercentage }}%
              </template>
              <template v-else>
                {{ props.item.marketing_activities | formatInteger }}<br>
                <template
                  v-if="props.item.turnover_expectation !== null && props.item.marketing_activities !== '0.00' && props.item.marketing_activities !== '0'">
                  {{ (props.item.marketing_activities / props.item.turnover_expectation) | formatPercentage }}%
                </template>
              </template>
              <div v-if="props.item.services && props.item.services != 0">
                {{ $t('sandoz.services') }} : {{ props.item.services | formatInteger }}
              </div>
            </td>
            <td>
              <div v-if="props.item.discount_gx_percentage || props.item.discount_otc_percentage">
                {{ $t('sandoz.gx') }}: {{ props.item.discount_gx_percentage | formatPercentage }}%<br>
                {{ $t('sandoz.otc') }}: {{ props.item.discount_otc_percentage | formatPercentage }}%
              </div>
              <div v-else>
                {{ props.item.discount_percentage | formatPercentage }}%
              </div>
            </td>
            <td>
              <template v-for="i in [1,2,3,4,5,6]">
                <template v-if="props.item['approval_date_' + i]">
                  <span v-if="i>1" :key="props.item.id + '-if-' + i">, </span>
                  <span :key="props.item.id + '-else-' + i"
                        :title="props.item['approval_person_' + i] + ' ' + props.item['approval_date_' + i]">{{
                      props.item['approver_' + i]
                    }}</span>
                </template>
              </template>

              <a v-if="props.item.next_approver_role" href="javascript:void(0);" @click="openApproverModal(props.item)">
                <fa icon="info-circle"></fa>
              </a>
            </td>
          </template>
          <template slot="custom-row-button" slot-scope="props">
            <div :ref="'controls_' + props.item.id" aria-label="approve controls" class="btn-group btn-group-sm">
              <b-dropdown
                v-if="props.item.kukos && props.item.kukos.data && props.item.kukos.data.length"
                :popper-opts="{ positionFixed: true }"
                boundary="window"
                variant="secondary">
                <template #button-content>
                  <fa class="mr-1 d-inline mt-1" icon="layer-group"/>
                </template>

                <b-dropdown-item v-for="kuko in props.item.kukos.data" :key="kuko.id" :to="{ name: 'sandoz.kuko.detail', params: {id: kuko.id} }">
                  #{{ kuko.id }} - {{ kuko.address1 }}
                </b-dropdown-item>
              </b-dropdown>

              <template v-if="props.item.compilance_check_file || props.item.compilance_check_selected !== null">
                <b-dropdown :popper-opts="{ positionFixed: true }" boundary="window" variant="primary btn-sm">
                  <template #button-content>
                    <fa class="mr-1 d-inline mt-1" icon="info-circle"/>
                  </template>

                  <template v-if="props.item.compliance_deviation">
                    <b-dropdown-item href="#">
                      {{ $t('sandoz.check_compliance_deviation') }}:- {{ props.item.compliance_deviation }}
                      <hr>
                    </b-dropdown-item>
                  </template>
                  <template v-if="props.item.compilance_check_file">
                    <b-dropdown-item href="#" @click.prevent="compliance(props.item.compilance_check_file)">
                      <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                        <o-button type="button" variant="primary">
                          <fa icon="file-word"/>
                        </o-button>
                      </div>
                      {{ props.item.compilance_check_file ? props.item.compilance_check_file.name : null }}
                      <hr>
                    </b-dropdown-item>
                  </template>
                  <template v-if="props.item.compilance_check_note">
                    <b-dropdown-item v-if="props.item.compilance_check_note" href="#">
                      {{ $t('sandoz.reason') }}:- {{ props.item.compilance_check_note }}
                    </b-dropdown-item>
                    <hr>
                  </template>
                  <template v-if="props.item.compilance_check_selected !== null">
                    <b-dropdown-item href="#">
                      {{ $t('sandoz.compliance_option_selected') }}:-
                      {{ props.item.compilance_check_selected ? 'Yes' : 'No' }}
                    </b-dropdown-item>
                  </template>
                </b-dropdown>
              </template>

              <b-dropdown :popper-opts="{ positionFixed: true }" boundary="window" variant="primary btn-sm">
                <template #button-content>
                  <fa class="mr-1 d-inline mt-1" icon="fa-paperclip"/>
                </template>

                <b-dropdown-item v-for="file in props.item.word_files.data" :key="file.id" href="#"
                                 @click.prevent="word(file)">
                  <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                    <o-button type="button" variant="primary">
                      <fa icon="file-word"/>
                    </o-button>
                  </div>
                  {{ file.file_name ? file.file_name.name : null }}
                </b-dropdown-item>
                <hr>
                <b-dropdown-item href="#">
                  <b-btn variant="primary" @click.prevent="addFile(props.item.id)">
                    {{ $t('sandoz.upload_file') }}
                  </b-btn>
                </b-dropdown-item>
              </b-dropdown>

              <button v-if="props.item.file_link_1" class="btn btn-secondary" @click="openLink(props.item.file_link_1)">
                <fa class="mr-1 d-inline mt-1" icon="link"/>
                <br>
                {{ $t('sandoz.file_1') }}
              </button>
              <button v-if="props.item.file_link_2" class="btn btn-secondary" @click="openLink(props.item.file_link_2)">
                <fa class="mr-1 d-inline mt-1" icon="link"/>
                <br>
                {{ $t('sandoz.file_2') }}
              </button>
              <button v-if="props.item.file_link_3" class="btn btn-secondary" @click="openLink(props.item.file_link_3)">
                <fa class="mr-1 d-inline mt-1" icon="link"/>
                <br>
                {{ $t('sandoz.file_3') }}
              </button>

              <router-link v-if="props.item.type.substr(0,3)=='KAM'"
                           :to="{ name: 'sandoz.kam.contract_detail', params: {id: props.item.id} }"
                           class="btn btn-secondary pt-3" style="width: 70px">
                {{ $t('sandoz.details') }}
              </router-link>

              <b-button v-if="Object.keys(props.item.latest_pdf.data).length" :disabled="downloading" type="button"
                        variant="secondary" @click.prevent="download(props.item.latest_pdf)">
                <fa class="mr-1 d-inline mt-1" icon="download"/>
                <br>
                {{ $t('sandoz.pdf') }}
              </b-button>
              <b-button v-if="Object.keys(props.item.latest_import_job.data).length" :disabled="downloading"
                        type="button"
                        variant="secondary" @click.prevent="xlsx(props.item.latest_import_job)">
                <fa class="mr-1 d-inline mt-1" icon="file-signature"/>
                <br>
                {{ $t('sandoz.xlsm') }}
              </b-button>

              <b-dropdown v-if="props.item.status != 'Rejected' && props.item.status != 'Feedback'"
                          :disabled="approving" :popper-opts="{ positionFixed: true }" boundary="window"
                          split variant="primary"
                          @click="approve(props.item.id)">
                <template #button-content>
                  <fa class="mr-1 d-inline mt-1" icon="check-circle"/>
                  <br>
                  {{ $t('sandoz.approve') }}
                </template>
                <b-dropdown-item href="#" @click.prevent="approvalFeedback('review', props.item)">
                  {{ $t('sandoz.changes_needed_review_again') }}
                </b-dropdown-item>
                <b-dropdown-item href="#" @click.prevent="approvalFeedback('restart', props.item)">
                  {{ $t('sandoz.changes_needed_restart') }}
                </b-dropdown-item>
                <b-dropdown-item href="#" @click.prevent="approvalFeedback('reject', props.item)">
                  {{ $t('sandoz.reject') }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </template>
        </o-table>
      </b-tab>
      <b-tab :active="totalIceContractApproval <= 0 && totalEduContractApproval > 0"
             :title="$t('sandoz.edu_contract_approvals') + ' (' + totalEduContractApproval + ')'"
             :title-item-class="totalEduContractApproval <= 0 ? 'd-none' : ''">
        <o-table ref="tableList" :custom-row-button="true" :enable-delete="false" :enable-edit="false"
                 :enable-new="false" :enable-view="false" :hide-if-empty="true" :title="''" class="sticky-last-row"
                 url="/api/sandoz/approvals?c_type=edu&include=master_address_single,latest_pdf,latest_import_job,word_files"
                 @total="handleEduContractTotal">
          <template slot="filter">
            <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)">
              <o-filter-text :title="$t('sandoz.contract_no')" column="contract_no"></o-filter-text>
              <o-filter-text :title="$t('sandoz.customer_external_id')" column="customer_external_id"></o-filter-text>
              <o-filter-text :title="$t('sandoz.responsible_sales_person')"
                             column="responsible_sales_person"></o-filter-text>
              <o-filter-select :items="status" :title="$t('sandoz.status')" column="status"></o-filter-select>
              <o-filter-select :items="years" :title="$t('sandoz.contract_year')"
                               column="contract_year"></o-filter-select>
            </o-filter>
          </template>
          <template slot="head">
            <o-table-header column="contract_no">{{ $t('sandoz.contract_no') }}</o-table-header>
            <o-table-header column="responsible_sales_person">{{
                $t('sandoz.responsible_sales_person')
              }}
            </o-table-header>
            <o-table-header column="contract_start">{{ $t('sandoz.contract_start') }}</o-table-header>
            <o-table-header column="status">{{ $t('sandoz.status') }}</o-table-header>
            <o-table-header :sortable="false" :title="$t('sandoz.name')">{{ $t('sandoz.name') }}</o-table-header>
            <o-table-header :title="$t('sandoz.no_of_medical_practices')" column="no_of_medical_practices">
              {{ $t('sandoz.no_of_medical_practices') }}
            </o-table-header>
            <o-table-header :title="$t('sandoz.max_threshold_per_hcp')" column="max_threshold_per_hcp">
              {{ $t('sandoz.max_threshold_per_hcp') }}
            </o-table-header>
            <o-table-header :title="$t('sandoz.amount_of_educational')" column="amount_of_educational">
              {{ $t('sandoz.amount_of_educational') }}
            </o-table-header>
            <o-table-header :title="$t('sandoz.actual_amount_of_educational')" column="actual_amount_of_educational">
              {{ $t('sandoz.actual_amount_of_educational') }}
            </o-table-header>
            <o-table-header :title="$t('sandoz.total_training_budget')" column="total_training_budget">{{
                $t('sandoz.total_training_budget')
              }}
            </o-table-header>
            <o-table-header :title="$t('sandoz.finished_approvals')" column="next_approver">
              {{ $t('sandoz.finished_approvals') }}
            </o-table-header>
            <th>&nbsp;</th>
          </template>
          <template slot="body" slot-scope="props">
            <td>{{ props.item.contract_no }}
              <router-link :to="{ name: contractRoute(props.item), params: { id: props.item.id }}">
                <fa icon="arrow-right"/>
              </router-link>
            </td>
            <td>{{ props.item.responsible_sales_person }}</td>
            <td>{{ props.item.contract_start | formatDate }}</td>
            <td>
              {{ $t('sandoz.' + props.item.status.toLowerCase()) }}
              <span v-if="props.item.reason_businesscase"
                    v-b-popover.hover="{ variant: 'info',  content: props.item.reason_businesscase }"
                    class="badge badge-warning">{{ $t('sandoz.business_case') }}</span>
              <span v-if="props.item.cap_exceeded"
                    class="badge badge-danger text-capitalize">{{ $t('sandoz.cap_exceeded') }}</span>
              <span v-if="props.item.deviation_outside_margin"
                    class="badge badge-orange">{{ $t('sandoz.deviation_outside_margin') }}</span>
              <span v-if="props.item.deviation_outside_margin === 0"
                    class="badge badge-success">{{ $t('sandoz.deviation_inside_margin') }}</span>
            </td>
            <td>
              <template v-if="props.item.master_address_single && props.item.master_address_single.data">
                <template
                  v-if="props.item.master_address_single.data.name || props.item.master_address_single.data.last_name">
                  {{
                    props.item.master_address_single.data.name + ' ' + props.item.master_address_single.data.last_name + (props.item.master_address_single.data.company_name ? ' (' + props.item.master_address_single.data.company_name + ')' : '')
                  }}
                </template>
                <template v-else>
                  {{ props.item.master_address_single.data.company_name }}
                </template>
              </template>
            </td>
            <td>
              {{ props.item.no_of_medical_practices | formatInteger }}
            </td>
            <td>
              {{ props.item.max_threshold_per_hcp | formatInteger }}
            </td>
            <td>{{ props.item.amount_of_educational | formatInteger }}</td>
            <td>
              {{ props.item.actual_amount_of_educational | formatInteger }}
            </td>
            <td>
              {{ props.item.total_training_budget | formatInteger }}
            </td>
            <td>
              <template v-for="i in [1,2,3,4,5,6]">
                <template v-if="props.item['approval_date_' + i]">
                  <span v-if="i>1" :key="props.item.id + '-if-' + i">, </span>
                  <span :key="props.item.id + '-else-' + i"
                        :title="props.item['approval_person_' + i] + ' ' + props.item['approval_date_' + i]">{{
                      props.item['approver_' + i]
                    }}</span>
                </template>
              </template>

              <a v-if="props.item.next_approver_role" href="javascript:void(0);" @click="openApproverModal(props.item)">
                <fa icon="info-circle"></fa>
              </a>
            </td>
          </template>
          <template slot="custom-row-button" slot-scope="props">
            <div :ref="'controls_' + props.item.id" aria-label="approve controls" class="btn-group btn-group-sm">
              <template v-if="props.item.compilance_check_file || props.item.compilance_check_selected !== null">
                <b-dropdown :popper-opts="{ positionFixed: true }" boundary="window" variant="primary btn-sm">
                  <template #button-content>
                    <fa class="mr-1 d-inline mt-1" icon="info-circle"/>
                  </template>

                  <template v-if="props.item.compliance_deviation">
                    <b-dropdown-item href="#">
                      {{ $t('sandoz.check_compliance_deviation') }}:- {{ props.item.compliance_deviation }}
                      <hr>
                    </b-dropdown-item>
                  </template>
                  <template v-if="props.item.compilance_check_file">
                    <b-dropdown-item href="#" @click.prevent="compliance(props.item.compilance_check_file)">
                      <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                        <o-button type="button" variant="primary">
                          <fa icon="file-word"/>
                        </o-button>
                      </div>
                      {{ props.item.compilance_check_file ? props.item.compilance_check_file.name : null }}
                      <hr>
                    </b-dropdown-item>
                  </template>
                  <template v-if="props.item.compilance_check_note">
                    <b-dropdown-item v-if="props.item.compilance_check_note" href="#">
                      {{ $t('sandoz.reason') }}:- {{ props.item.compilance_check_note }}
                    </b-dropdown-item>
                    <hr>
                  </template>
                  <template v-if="props.item.compilance_check_selected !== null">
                    <b-dropdown-item href="#">
                      {{ $t('sandoz.compliance_option_selected') }}:-
                      {{ props.item.compilance_check_selected ? 'Yes' : 'No' }}
                    </b-dropdown-item>
                  </template>
                </b-dropdown>
              </template>

              <b-dropdown :popper-opts="{ positionFixed: true }" boundary="window" variant="primary btn-sm">
                <template #button-content>
                  <fa class="mr-1 d-inline mt-1" icon="fa-paperclip"/>
                </template>

                <b-dropdown-item v-for="file in props.item.word_files.data" :key="file.id" href="#"
                                 @click.prevent="word(file)">
                  <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                    <o-button type="button" variant="primary">
                      <fa icon="file-word"/>
                    </o-button>
                  </div>
                  {{ file.file_name ? file.file_name.name : null }}
                </b-dropdown-item>
                <hr>
                <b-dropdown-item href="#">
                  <b-btn variant="primary" @click.prevent="addFile(props.item.id)">
                    {{ $t('sandoz.upload_file') }}
                  </b-btn>
                </b-dropdown-item>
              </b-dropdown>

              <button v-if="props.item.file_link_1" class="btn btn-secondary" @click="openLink(props.item.file_link_1)">
                <fa class="mr-1 d-inline mt-1" icon="link"/>
                <br>
                {{ $t('sandoz.file_1') }}
              </button>
              <button v-if="props.item.file_link_2" class="btn btn-secondary" @click="openLink(props.item.file_link_2)">
                <fa class="mr-1 d-inline mt-1" icon="link"/>
                <br>
                {{ $t('sandoz.file_2') }}
              </button>
              <button v-if="props.item.file_link_3" class="btn btn-secondary" @click="openLink(props.item.file_link_3)">
                <fa class="mr-1 d-inline mt-1" icon="link"/>
                <br>
                {{ $t('sandoz.file_3') }}
              </button>

              <router-link v-if="props.item.type.substr(0,3)=='KAM'"
                           :to="{ name: 'sandoz.kam.contract_detail', params: {id: props.item.id} }"
                           class="btn btn-secondary pt-3" style="width: 70px">
                {{ $t('sandoz.details') }}
              </router-link>

              <b-button v-if="Object.keys(props.item.latest_pdf.data).length" :disabled="downloading" type="button"
                        variant="secondary" @click.prevent="download(props.item.latest_pdf)">
                <fa class="mr-1 d-inline mt-1" icon="download"/>
                <br>
                {{ $t('sandoz.pdf') }}
              </b-button>
              <b-button v-if="Object.keys(props.item.latest_import_job.data).length" :disabled="downloading"
                        type="button"
                        variant="secondary" @click.prevent="xlsx(props.item.latest_import_job)">
                <fa class="mr-1 d-inline mt-1" icon="file-signature"/>
                <br>
                {{ $t('sandoz.xlsm') }}
              </b-button>

              <b-dropdown v-if="props.item.status != 'Rejected' && props.item.status != 'Feedback'"
                          :disabled="approving" :popper-opts="{ positionFixed: true }" boundary="window"
                          split variant="primary"
                          @click="approve(props.item.id)">
                <template #button-content>
                  <fa class="mr-1 d-inline mt-1" icon="check-circle"/>
                  <br>
                  {{ $t('sandoz.approve') }}
                </template>
                <b-dropdown-item href="#" @click.prevent="approvalFeedback('review', props.item)">
                  {{ $t('sandoz.changes_needed_review_again') }}
                </b-dropdown-item>
                <b-dropdown-item href="#" @click.prevent="approvalFeedback('restart', props.item)">
                  {{ $t('sandoz.changes_needed_restart') }}
                </b-dropdown-item>
                <b-dropdown-item href="#" @click.prevent="approvalFeedback('reject', props.item)">
                  {{ $t('sandoz.reject') }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </template>
        </o-table>
      </b-tab>
      <b-tab :active="totalIceContractApproval <= 0 && totalEduContractApproval <= 0 && totalKukoApproval > 0"
             :title="$t('sandoz.kuko_approvals')  + ' (' + totalKukoApproval + ')'"
             :title-item-class="totalKukoApproval <= 0 ? 'd-none' : ''">
        <o-table ref="kukoTableList" :custom-row-button="true" :enable-delete="false" :enable-edit="false"
                 :enable-new="false" :enable-view="false" :hide-if-empty="true" :title="''" class="sticky-last-row"
                 url="/api/kuko_approval_steps?filter[kuko_status]=Committed,Approved&&filter[approver]=me&include=next_approver,kuko,kuko.contracts,kuko.contracts.latest_pdf,kuko.user,kuko.special_order_attachments,kuko.otc_product_attachments,kuko.files.user"
                 @total="handleKukoTotal">
          <template slot="head">
            <o-table-header column="id">{{ $t('sandoz.kuko_no') }}</o-table-header>
            <o-table-header :sortable="false" column="customer">{{ $t('sandoz.customer') }}</o-table-header>
            <o-table-header column="account_category">{{ $t('sandoz.account_category') }}</o-table-header>
            <o-table-header :sortable="true" column="kuko_date">{{ $t('sandoz.request_date') }}</o-table-header>
            <o-table-header :sortable="true" column="status">{{ $t('sandoz.status') }}</o-table-header>
            <o-table-header :sortable="false">{{ $t('sandoz.link') }}</o-table-header>
            <o-table-header :sortable="false" column="next_approver">{{ $t('sandoz.next_approver') }}</o-table-header>
            <o-table-header :sortable="false" column="user.name">{{ $t('sandoz.requestor') }}</o-table-header>
            <th>&nbsp;</th>
          </template>

          <template slot="body" slot-scope="props">
            <td>#{{ props.item.kuko.data.id }}</td>
            <td>{{ props.item.kuko.data.address1 }}</td>
            <td>
              <template v-if="props.item.kuko.data.account_category == 'individual_account'">
                {{ $t('sandoz.individual_account') }}
              </template>
              <template v-if="props.item.kuko.data.account_category == 'buying_group'">{{ $t('sandoz.buying_group') }}
              </template>
              <template v-if="props.item.kuko.data.account_category == 'smart_selection'">
                {{ $t('sandoz.smart_selection') }}
              </template>
            </td>
            <td>{{ props.item.kuko.data.kuko_date | formatDate }}</td>
            <td>{{ props.item.kuko.data.status }}</td>
            <td>
              <template v-if="props.item.kuko.data.contracts && props.item.kuko.data.contracts.data.length">
                <div v-for="contract in props.item.kuko.data.contracts.data" :key="'contract-' + contract.id" class="mb-1">
                  <router-link :to="{ path: '/sandoz/contracts/view/' + contract.id }">
                    <fa icon="file-contract"/>
                  </router-link>
                </div>
              </template>
              <template v-else-if="props.item.kuko.data.files && props.item.kuko.data.files.data.length">
                <div v-for="file in props.item.kuko.data.files.data" :key="'file-' + file.id" class="mb-1">
                  <a href="#" @click.prevent="kukoword(file)">
                    <fa icon="file-word"/>
                  </a>
                </div>
              </template>
              <template v-else>
                <b-badge variant="danger">
                  {{ $t('sandoz.no_object_linked') }}
                </b-badge>
              </template>
            </td>
            <td>{{ props.item.next_approver.data ? props.item.next_approver.data.approval_role : '' }}</td>
            <td>{{ props.item.kuko.data.user ? props.item.kuko.data.user.data.name : '-' }}</td>
          </template>

          <template slot="custom-row-button" slot-scope="props">
            <div :ref="'controls_' + props.item.id" aria-label="approve controls" class="btn-group btn-group-sm">

              <b-dropdown
                v-if="props.item.kuko.data.contracts && props.item.kuko.data.contracts.data && props.item.kuko.data.contracts.data.length"
                :popper-opts="{ positionFixed: true }"
                boundary="window"
                variant="secondary">
                <template #button-content>
                  <fa class="mr-1 d-inline mt-1" icon="file-contract"/>
                </template>

                <b-dropdown-text v-for="contract in props.item.kuko.data.contracts.data" :key="contract.id" class="d-flex align-items-center justify-content-between">
                  <router-link :to="{ path: '/sandoz/contracts/view/' + contract.id }">
                    {{ contract.contract_no || ('#' + contract.id) }}
                  </router-link>
                  <span v-if="contract.latest_pdf && contract.latest_pdf.data && contract.latest_pdf.data.id" class="ml-2 text-danger" style="cursor: pointer;" @click.prevent.stop="download(contract.latest_pdf)">
                    <fa icon="file-pdf"/>
                  </span>
                </b-dropdown-text>
              </b-dropdown>

              <b-dropdown :popper-opts="{ positionFixed: true }" boundary="window" variant="primary btn-sm">
                <template #button-content>
                  <fa class="mr-1 d-inline mt-1" icon="fa-paperclip"/>
                </template>

                <b-dropdown-item v-for="file in props.item.kuko.data.files.data" :key="file.id"
                                 href="#" @click.prevent="kukoword(file)">
                  <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                    <o-button type="button" variant="primary">
                      <fa icon="file-word"/>
                    </o-button>
                  </div>
                  {{ file.file_name ? file.file_name.name : null }}
                </b-dropdown-item>
                <hr>
                <b-dropdown-item href="#">
                  <b-btn variant="primary" @click.prevent="kukoaddFile(props.item.kuko.data.id)">
                    {{ $t('sandoz.upload_file') }}
                  </b-btn>
                </b-dropdown-item>
              </b-dropdown>

              <b-dropdown
                v-if="props.item.status != 'Rejected' && props.item.status != 'Feedback' && (props.item.kuko.data.special_order_attachments.data.length > 0 || props.item.kuko.data.otc_product_attachments.data.length > 0)"
                :disabled="approving" :popper-opts="{ positionFixed: true }"
                boundary="window"
                variant="secondary">
                <template #button-content>
                  <fa class="mr-1 d-inline mt-1" icon="link"/>
                </template>

                <b-dropdown-item-button v-for="download in props.item.kuko.data.otc_product_attachments.data"
                                        :key="download.id"
                                        @click="downloadKukoAttachment('otc_product_attachments', download)">
                  {{ download.file.substr(11) }}
                </b-dropdown-item-button>
                <b-dropdown-item-button v-for="download in props.item.kuko.data.special_order_attachments.data"
                                        :key="download.id"
                                        @click="downloadKukoAttachment('special_order_attachments', download)">
                  {{ download.file.substr(11) }}
                </b-dropdown-item-button>

              </b-dropdown>

              <router-link :to="{ name: 'sandoz.kuko.detail', params: {id: props.item.kuko.data.id} }"
                           class="btn btn-secondary pt-2" style="width: 70px">
                {{ $t('sandoz.kuko_details') }}
              </router-link>

              <b-dropdown v-if="props.item.status != 'Rejected' && props.item.status != 'Feedback'"
                          :disabled="approving" :popper-opts="{ positionFixed: true }" boundary="window"
                          split variant="primary"
                          @click="approveKuko(props.item.id)">
                <template #button-content>
                  <fa class="mr-1 d-inline mt-1" icon="check-circle"/>
                  <br>
                  {{ $t('sandoz.approve') }}
                </template>
                <b-dropdown-item href="#" @click.prevent="approvalFeedbackKuko('review', props.item)">
                  {{ $t('sandoz.changes_needed_review_again') }}
                </b-dropdown-item>
                <b-dropdown-item href="#" @click.prevent="approvalFeedbackKuko('restart', props.item)">
                  {{ $t('sandoz.changes_needed_restart') }}
                </b-dropdown-item>
                <b-dropdown-item href="#" @click.prevent="approvalFeedbackKuko('reject', props.item)">
                  {{ $t('sandoz.reject') }}
                </b-dropdown-item>
              </b-dropdown>

            </div>
          </template>

        </o-table>
      </b-tab>
    </b-tabs>

    <div v-if="noApprovalsPending" class="card text-center p-5 my-4 shadow-sm border-0 bg-light">
      <div class="card-body py-4">
        <div class="mb-3 text-success">
          <fa icon="check-circle" size="4x" />
        </div>
        <h4 class="card-title font-weight-bold text-dark mb-2">
          {{ $t('sandoz.no_approvals_pending_title') }}
        </h4>
        <p class="card-text text-muted mb-0 mx-auto" style="max-width: 500px;">
          {{ $t('sandoz.no_approvals_pending_text') }}
        </p>
      </div>
    </div>
    <div>
      <b-form-file ref="fileinput"
                   accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                   class="d-none"
                   plain
                   @change="addToWordFiles"></b-form-file>
      <b-form-file ref="fileinput1"
                   accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                   class="d-none"
                   plain
                   @change="addToKukoWordFiles"></b-form-file>
      <approver-modal ref="approverModal" :contract="contract"/>

      <b-modal ref="turnoverModal" :title="$t('sandoz.turnover_information')">
        <table v-if="contract" class="table table-sm">
          <thead>
          <tr>
            <th></th>
            <th class="text-right">{{ $t('sandoz.turnover') }}</th>
            <th class="text-right">{{ $t('sandoz.turnover_expectation') }}</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <th>{{ $t('sandoz.gx') }}</th>
            <td class="text-right">{{ contract.turnover_gx | formatNumber }}</td>
            <td class="text-right">{{ contract.turnover_gx_expectation | formatNumber }}</td>
          </tr>
          <tr>
            <th>{{ $t('sandoz.otc') }}</th>
            <td class="text-right">{{ contract.turnover_otc | formatNumber }}</td>
            <td class="text-right">{{ contract.turnover_otc_expectation | formatNumber }}</td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <th>{{ $t('sandoz.total') }}</th>
            <td class="text-right">{{ contract.turnover | formatNumber }}</td>
            <td class="text-right">{{ contract.turnover_expectation | formatNumber }}</td>
          </tr>
          </tfoot>
        </table>
      </b-modal>

      <b-modal ref="approvalFeedbackModal" :ok-disabled="!feedbackComment" :title="feedbackModalTitle"
               @ok="submitFeedback">
        {{ feedbackModalText }}

        <o-textarea v-model="feedbackComment" :label="$t('sandoz.feedback')" class="mt-4"></o-textarea>
      </b-modal>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import axios from 'axios'
import ApproverModal from './partials/ApproverModal.vue'
import {contractYears} from '../../utils/contractYear'


export default {
  data: () => ({
    status: [],
    years: [],
    approving: false,
    downloading: false,
    feedbackType: '',
    feedbackObject: '',
    feedbackModalTitle: '',
    feedbackModalText: '',
    feedbackComment: '',
    currentItem: null,
    contract: null,
    uploadContract: null,
    uploadKuko: null,
    totalIceContractApproval: 0,
    totalEduContractApproval: 0,
    totalKukoApproval: 0,
    iceContractLoaded: false,
    eduContractLoaded: false,
    kukoLoaded: false
  }),
  components: {
    ApproverModal
  },
  computed: {
    ...mapGetters({
      user: 'auth/user'
    }),
    isFullyLoaded() {
      return this.iceContractLoaded && this.eduContractLoaded && this.kukoLoaded
    },
    noApprovalsPending() {
      return this.isFullyLoaded &&
        this.totalIceContractApproval <= 0 &&
        this.totalEduContractApproval <= 0 &&
        this.totalKukoApproval <= 0
    }
  },
  created() {
    this.years = contractYears()

    this.status = [
      {value: 'Planned', text: this.$i18n.t('sandoz.planned')},
      {value: 'Committed', text: this.$i18n.t('sandoz.committed')},
      {value: 'Signed', text: this.$i18n.t('sandoz.signed')},
      {value: 'Lost', text: this.$i18n.t('sandoz.lost')},
      {value: 'Cancelled', text: this.$i18n.t('sandoz.cancelled')},
      {value: 'ZeroInvest', text: this.$i18n.t('sandoz.zero_invest')}
    ]
  },
  methods: {
    forceFileDownload(response, title) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', title)
      document.body.appendChild(link)
      link.click()
    },
    downloadKukoAttachment(type, download) {
      axios.get('/api/kukos/attachments/download/' + download.id + '/' + type, {responseType: 'arraybuffer'})
        .then((response) => {
          this.forceFileDownload(response, download.file.substr(11))
        }).catch((error) => {
        if (error.response.status === 404) {
          this.$notify({
            title: this.$i18n.t('core.error'),
            text: this.$i18n.t('sandoz.file_not_found'),
            type: 'error'
          })
        } else {
          this.$notify({
            title: this.$i18n.t('core.error_alert_title'),
            text: this.$i18n.t('core.error_alert_text'),
            type: 'error'
          })
        }
      })
    },
    approvalFeedbackKuko(feedbackType, item) {
      this.currentItem = item
      switch (feedbackType) {
        case 'reject':
          this.feedbackModalTitle = this.$t('sandoz.approval_reject')
          this.feedbackModalText = this.$t('sandoz.approval_reject_kuko_text')
          break
        case 'restart':
          this.feedbackModalTitle = this.$t('sandoz.approval_restart')
          this.feedbackModalText = this.$t('sandoz.approval_restart_kuko_text')
          break
        case 'review':
          this.feedbackModalTitle = this.$t('sandoz.approval_review')
          this.feedbackModalText = this.$t('sandoz.approval_review_kuko_text')
          break
      }
      this.feedbackType = feedbackType
      this.feedbackObject = 'kuko'
      this.$refs.approvalFeedbackModal.show()
    },
    approvalFeedback(feedbackType, item) {
      this.currentItem = item
      switch (feedbackType) {
        case 'reject':
          this.feedbackModalTitle = this.$t('sandoz.approval_reject')
          this.feedbackModalText = this.$t('sandoz.approval_reject_text')
          break
        case 'restart':
          this.feedbackModalTitle = this.$t('sandoz.approval_restart')
          this.feedbackModalText = this.$t('sandoz.approval_restart_text')
          break
        case 'review':
          this.feedbackModalTitle = this.$t('sandoz.approval_review')
          this.feedbackModalText = this.$t('sandoz.approval_review_text')
          break
      }
      this.feedbackType = feedbackType
      this.feedbackObject = 'contract'
      this.$refs.approvalFeedbackModal.show()
    },
    openTurnoverModal(contract) {
      this.contract = contract
      this.$refs.turnoverModal.show()
    },
    openApproverModal(contract) {
      this.contract = contract
      this.$refs.approverModal.showDialog()
    },
    closeApproverModal() {
      this.contract = null
      this.$refs.approverModal.hideDialog()
    },
    submitFeedback() {
      var self = this
      self.approving = true

      let url = this.feedbackObject == 'kuko' ? `/api/kukos/${this.currentItem.id}/feedback` : `/api/sandoz/approvals/${this.currentItem.id}/feedback`

      axios.post(url, {
        comment: this.feedbackComment,
        feedbackType: this.feedbackType
      }).then(response => {
        this.feedbackComment = ''
        this.$refs.approvalFeedbackModal.hide()
        if (this.feedbackObject == 'kuko') {
          this.$refs.kukoTableList.search()
        } else {
          this.$refs.tableList.search()
        }
        self.approving = false
      })
    },
    approveKuko(id) {
      axios
        .post(`/api/kuko_approval_steps/${id}/approve`)
        .then(response => {
          this.$refs.kukoTableList.search()
        })
        .catch(error => {
          let text = this.$i18n.t('core.error_alert_text')
          if (error.response && error.response.data && error.response.data.message) {
            const msg = error.response.data.message
            if (msg === 'kuko_linked_contract_required') {
              text = this.$i18n.t('sandoz.kuko_linked_contract_required')
            } else {
              text = msg
            }
          }
          this.$notify({
            title: this.$i18n.t('core.error_alert_title'),
            text: text,
            type: 'error'
          })
        })
    },
    approve(id) {
      var self = this
      self.approving = true

      axios
        .post('/api/sandoz/approvals/approve', {id: id})
        .then((response) => {
          self.$notify({
            title: self.$i18n.t('sandoz.successful'),
            text: self.$i18n.t('sandoz.approve_msg')
          })
          self.approving = false
          self.$refs['controls_' + id].innerHTML = '<span class="badge badge-success">' +
            self.$i18n.t('sandoz.approved') +
            '</span>'
        })
        .catch((error) => {
          self.approving = false

          let errorText = self.$i18n.t('core.error_alert_text')
          if (error.response && error.response.status === 403 && error.response.data && error.response.data.error) {
            errorText = error.response.data.error
          }

          self.$notify({
            title: self.$i18n.t('core.error_alert_title'),
            text: errorText,
            type: 'error'
          })
        })
    },
    openLink(link) {
      window.open(link, '_blank')
    },
    download(pdf) {
      const self = this
      self.downloading = true

      if (pdf.data.length === 0) {
        self.$notify({
          title: self.$i18n.t('core.error_alert_title'),
          text: self.$i18n.t('sandoz.pdf_not_found'),
          type: 'error'
        })
        return
      }

      if (pdf) {
        axios.post('/api/sandoz/contract_pdfs/download', {'id': pdf.data.id}, {responseType: 'arraybuffer'})
          .then((response) => {
            require('downloadjs')(response.data, pdf.data.file_name + '.pdf', 'application/pdf')
            self.downloading = false
          }).catch((error) => {
          self.downloading = false
          self.$notify({
            title: self.$i18n.t('core.error_alert_title'),
            text: self.$i18n.t('core.error_alert_text'),
            type: 'error'
          })
        })
      }
    },
    xlsx(job) {
      const self = this
      self.downloading = true

      if (Object.keys(job.data).length) {
        axios.post('/api/sandoz/import_jobs/download', {'id': job.data.id}, {responseType: 'arraybuffer'})
          .then((response) => {
            require('downloadjs')(response.data, job.data.file_name, 'application/vnd.ms-excel')
            self.downloading = false
          }).catch((error) => {
          self.downloading = false
          self.$notify({
            title: self.$i18n.t('core.error_alert_title'),
            text: self.$i18n.t('core.error_alert_text'),
            type: 'error'
          })
        })
      }
    },
    contractRoute: function (item) {
      let routeName = 'sandoz.contract_detail'

      if (['KAM_APO', 'KAM_SD', 'KAM_WHS', 'KAM_DIVERSE_HOSP', 'KAM_DIVERSE_INSUR', 'KAM_SD_SORTALYS', 'BIOS_KAM_APO', 'BIOS_KAM_WHS'].includes(item.type)) {
        routeName = 'sandoz.kam.contract_detail'
      } else if (['APO', 'BIOS_APO', 'CNS', 'HEIM', 'IMMUNO', 'ONCO', 'SD', 'SD_SORTALYS', 'CNS_SORTALYS', 'IMMUNO_SORTALYS', 'HIGHSPEC_SORTALYS', 'APO_OTC'].includes(item.type)) {
        routeName = 'sandoz.ice_peak.contract_detail'
      } else if (['SD_EDU', 'CNS_EDU', 'IMMUNO_EDU', 'ONCO_EDU', 'KAM_SD_EDU', 'APO_EDU', 'KAM_APO_EDU'].includes(item.type)) {
        routeName = 'sandoz.educational.contract_detail'
      }

      return routeName
    },
    addToWordFiles(evt) {
      var fileName = evt.target.value.replace(/^.*[\\/]/, '')
      var files = evt.target.files
      var file = files[0]

      if (!file) {
        return
      }

      if (file) {
        var reader = new window.FileReader()
        const self = this
        reader.onload = function (readerEvt) {
          let wordOb = {
            contract_id: self.uploadContract,
            user_id: self.user.id,
            user: self.user,
            file_name: {
              data: readerEvt.target.result,
              name: fileName
            }
          }
          self.uploadFileToContract(wordOb)
        }
        reader.readAsDataURL(file)
      }
    },
    addFile(id) {
      this.uploadContract = id
      this.$refs.fileinput.$refs.input.click()
    },
    uploadFileToContract(data) {
      axios
        .post(`/api/sandoz/contract_word_file/new`, data)
        .then(response => {
          this.uploadContract = null

          this.$notify({
            text: this.$i18n.t('core.file_uploaded'),
            type: 'success'
          })
          window.location.reload();
        })
    },
    word(file) {
      axios.post('/api/sandoz/contract_word_file/download', {
        'id': file.id
      }, {responseType: 'arraybuffer'})
        .then((response) => {
          require('downloadjs')(
            response.data,
            file.file_name.name,
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
          )
        }).catch((error) => {
        console.log(error)
      })
    },
    kukoword(file) {
      axios.post('/api/sandoz/kuko_file/download', {
        'id': file.id
      }, {responseType: 'arraybuffer'})
        .then((response) => {
          require('downloadjs')(
            response.data,
            file.file_name.name,
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
          )
        }).catch((error) => {
        console.log(error)
      })
    },
    compliance(file) {
      console.log("file", file)
      axios.post('/api/sandoz/contract_compilance_file/download', {
        'file': file
      }, {responseType: 'arraybuffer'})
        .then((response) => {
          require('downloadjs')(
            response.data,
            file.name,
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
          )
        }).catch((error) => {
        console.log(error)
      })
    },
    addToKukoWordFiles(evt) {
      var fileName = evt.target.value.replace(/^.*[\\/]/, '')
      var files = evt.target.files
      var file = files[0]

      if (!file) {
        return
      }

      if (file) {
        var reader = new window.FileReader()
        const self = this
        reader.onload = function (readerEvt) {
          let wordOb = {
            kuko_id: self.uploadKuko,
            user_id: self.user.id,
            user: self.user,
            file_name: {
              data: readerEvt.target.result,
              name: fileName
            }
          }
          self.uploadFileToKuko(wordOb)
        }
        reader.readAsDataURL(file)
      }
    },
    kukoaddFile(id) {
      this.uploadKuko = id
      this.$refs.fileinput1.$refs.input.click()
    },
    uploadFileToKuko(data) {
      axios
        .post(`/api/sandoz/kuko_file/new`, data)
        .then(response => {
          this.uploadKuko = null

          this.$notify({
            text: this.$i18n.t('core.file_uploaded'),
            type: 'success'
          })
          window.location.reload();
        })
    },
    handleContractTotal: function (total) {
      this.totalContractApproval = total
    },
    handleIceContractTotal: function (total) {
      this.totalIceContractApproval = total
      this.iceContractLoaded = true
    },
    handleEduContractTotal: function (total) {
      this.totalEduContractApproval = total
      this.eduContractLoaded = true
    },
    handleKukoTotal: function (total) {
      this.totalKukoApproval = total
      this.kukoLoaded = true
    }
  }
}
</script>

<style>
.badge-orange {
  background-color: orange !important;
  color: white !important;
}
</style>
